export default {"src":"/_next/static/media/circle-preloader.cb67c373.svg","height":150,"width":150};